/**
 * Vrátí URL mapio serveru
 *
 * @return URL nebo `undefined` pokud nešlo detekovat
 * @ignore
 */
export function getMapioServerUrl(): string | undefined {
    const global = window as any;
    if (global.MAPIO_URL) {
        return global.MAPIO_URL;
    }
    if (global.appConfig && global.appConfig.dependUrls && global.appConfig.dependUrls.mapio) {
        return global.appConfig.dependUrls.mapio;
    }
    return undefined;
}
